import React from 'react';
import ForecastQueryRenderer from '../../../../../../../ForecastQueryRenderer';
import BulkInvoiceCreateModal, { BulkInvoiceCreateModalQuery } from './BulkInvoiceCreateModal';
function BulkInvoiceCreateModalQueryWrapper({ companyProjectId, projectPeriodIds, closeModal, onStay, }) {
    return (React.createElement(ForecastQueryRenderer, { key: "query-render-time_reg_modal_update", query: BulkInvoiceCreateModalQuery, modal: true, variables: { companyProjectId }, render: (relayProps) => {
            return (React.createElement(BulkInvoiceCreateModal, Object.assign({}, relayProps, { onStay: onStay, projectPeriodIds: projectPeriodIds, closeModal: closeModal })));
        } }));
}
export default BulkInvoiceCreateModalQueryWrapper;
